module.exports = __webpack_public_path__ + "img/z-adimg5-4.9a0f20e2.png";